// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"qy-z","heading":"ry-z","outfitFeedbackSection":"sy-z"};